const BaseConfigService = require('./BaseConfigService');

/**
 * Samsung Pay Configuration Service
 * 
 * Manages Samsung Pay specific configuration with validation and defaults
 */
class SamsungPayConfigService extends BaseConfigService {

  /**
   * Get default Samsung Pay configuration
   */
  _getDefaultConfig() {
    return {
      code: null,
      environment: null,
      service_id: null,
      merchant_name: null,
      total_price: null,
      currency_code: null,
      country_code: null,
      fee: null,
      fee_description: null,
      flow: null,
      payment_url: null,
      pg_code: null,
    };
  }


  /**
   * Apply configuration with mappings
   */
  _applyConfig(config) {
    const mappings = {
      code: 'code',
      environment: 'environment',
      product_id: 'service_id',
      merchant_name: 'merchant_name',
      total_price: 'total_price',
      currency_code: 'currency_code',
      country_code: 'country_code',
      fee: 'fee',
      fee_description: 'fee_description',
      flow: 'flow',
      payment_url: 'payment_url',
      pg_code: 'pg_code',
      samsungPayLoaded: 'samsungPayLoaded',
    };

    Object.entries(mappings).forEach(([sourceKey, targetKey]) => {
      if (typeof config[sourceKey] !== 'undefined') {
        this._config[targetKey] = config[sourceKey];
      }
    });
  }

  /**
   * Check if Samsung Pay is configured
   */
  isConfigured() {
    return !!(this._config.code && this._config.service_id);
  }
}

// Export singleton instance
module.exports = new SamsungPayConfigService();